import React from 'react';
import AccreditationBaseTab from './AccreditationBaseTab';

export default function TermsAndAttestationsTab(props) {
    return <AccreditationBaseTab tabType="terms" {...props} />;
}